const getters = {
    showCart: state => state.showCart,
    shoppingCart: state => state.shoppingCart,
    shoppingCartCount: state => state.shoppingCartCount,
    venues: state => state.venues,
    categories: state => state.categories,
    products: state => state.products,
    productsStatus: state => state.productsStatus,
    productsErrors: state => state.productsErrors,
    shoppingErrors: state => state.shoppingErrors,
    paymentStatus: state => state.paymentStatus,
    paymentErrors: state => state.paymentErrors,

    isBookable: state => product => {
        let currentProd = state.shoppingCart.find(p => p.product_id === product.product_id);

        if (!currentProd) {
            return true;
        }

        if (!_.isNull(product.product_order_qty_max)) {
            if (currentProd.product_quantity >= product.product_order_qty_max) {
                return false;
            }
        }

        return true;
    },
    productAvailableQtyInCart: state => product => {
        let currentProd = state.shoppingCart.find(p => p.product_id === product.product_id);

        if (!currentProd) {
            if (product.product_quantity - product.product_booked < 0) {
                return 0;
            }

            return product.product_quantity - product.product_booked;
        }

        if (product.product_quantity - product.product_booked - currentProd.product_quantity < 0) {
            return 0;
        }

        return product.product_quantity - product.product_booked - currentProd.product_quantity;
    },
};

export default getters;
